export const debounce = function(fn, timeoutID, delay) {
  return function() {
    clearTimeout(timeoutID);
    const args = arguments;
    const that = this;
    return setTimeout(function() {
      fn.apply(that, args)
    }, delay);
  };
};
